import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { AccountComponent } from './Components/account/account.component';
import { AwardComponent } from './Components/award/award.component';
import { BoothDetailComponent } from './Components/booth-detail/booth-detail.component';
import { BoothEnquiryComponent } from './Components/booth-enquiry/booth-enquiry.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { NewExhibComponent } from './Components/exhib/new-exhib/new-exhib.component';
import { ViewExhibComponent } from './Components/exhib/view-exhib/view-exhib.component';
import { ExhibitionComponent } from './Components/exhibition/exhibition.component';
import { FeeComponent } from './Components/fee/fee.component';
import { HandbookComponent } from './Components/handbook/handbook.component';
import { IndexCoreComponent } from './Components/index-core/index-core.component';
import { JudgeCriteriaComponent } from './Components/judge-criteria/judge-criteria.component';
import { ProfileComponent } from './Components/profile/profile.component';
import { ProgramComponent } from './Components/program/program.component';
import { RubricComponent } from './Components/rubric/rubric.component';
import { VenueComponent } from './Components/venue/venue.component';
import { VisitorRegisterComponent } from './Components/visitor-register/visitor-register.component';
import { AccommodationComponent } from './Components/accomodation/accomodation.component';
import { SettingsComponent } from './Components/settings/settings.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { DashboardAwardComponent } from './Components/dashboard-award/dashboard.component';
import { VisitorBoardComponent } from './Components/visitor-register/visitor-board/visitor-board.component';
import { DashboardBoradComponent } from './Components/dashboard-borad/dashboard-borad.component';

const routes: Routes = [
{ path: '', component: IndexCoreComponent },
{ path: 'register', component: AccountComponent },
{ path: 'contact-us', component: ContactUsComponent },
{ path: 'about-us', component: AboutUsComponent },
{ path: 'judge-criteria', component: JudgeCriteriaComponent },
{ path: 'fee', component: FeeComponent },
{ path: 'award', component: AwardComponent },
{ path: 'profile', component: ProfileComponent },
{ path: 'program', component: ProgramComponent },
{ path: 'handbook', component: HandbookComponent },
{ path: 'visitor-register', component: VisitorRegisterComponent },
{ path: 'visitor-board', component: VisitorBoardComponent },
{ path: 'venue', component: VenueComponent },
{ path: 'booth-detail', component: BoothDetailComponent },
{ path: 'booth-enquiry', component: BoothEnquiryComponent },
{ path: 'innovation', component: ExhibitionComponent },
{ path: 'innovation/add', component: NewExhibComponent },
{ path: 'innovation/edit', component: NewExhibComponent },
{ path: 'innovation/view', component: ViewExhibComponent },
{ path: 'innovation/viewMark', component: RubricComponent },
{ path: 'innovation/public-board', component: DashboardBoradComponent },
{ path: 'accommodation', component: AccommodationComponent },
{ path: 'settings', component: SettingsComponent },
{ path: 'innovation/dashboard', component: DashboardComponent },
{ path: 'innovation/award-dashboard', component: DashboardAwardComponent },
]
@NgModule({
  imports: [RouterModule.forRoot(routes,
     {
      useHash: true,
      scrollPositionRestoration: 'enabled', // Add options right here
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
